// values for [direction] field
import { ISelectListItem } from "../models";

export enum DirectionEnum {
  PickUp = "A", // to a work - pick-up
  DropOff = "B", // from a work - drop-off
  Both = "AB", // both - pick-up / drop-off
  None = "X",
}
export const MAIN_DIRECTIONS = [
  DirectionEnum.PickUp,
  DirectionEnum.DropOff,
  DirectionEnum.Both,
];
export const MAIN_DIRECTIONS_SELECT_ITEMS: ISelectListItem[] =
  MAIN_DIRECTIONS.map(direction => ({
    label: direction,
    value: direction,
  }));

export type TRestrictedDirection = DirectionEnum.PickUp | DirectionEnum.DropOff;
